import React from 'react';
import ArticleAuthors from '../ArticleAuthors';
import ArticleContributors from '../ArticleContributors';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import styles from './ArticleHeroImageRight.module.scss';
import Badge from 'components/includes/Badge/Badge';
import { ImageField, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import { ArticleHeroProps } from '../ArticleHeroTypes';

function ArticleHeroImageRight({ article, anchorId, tagValues }: ArticleHeroProps) {
  if (!article) return null;

  const authorsLength = article.articleAuthor?.targetItems.length ?? 0;

  return (
    <section id={anchorId} className="container py-3 py-md-5 py-lg-8">
      <div className="row flex-lg-row flex-column-reverse">
        {/* Text Section */}
        <div className="col-12 col-lg-6">
          {(article.contentGroup || article.articleCategory) && (
            <div className="d-flex align-items-center gap-2">
              {tagValues.firstTag && <div className="h5 text-nowrap">{tagValues.firstTag}</div>}
              {tagValues.secondTag && <Badge>{tagValues.secondTag}</Badge>}
            </div>
          )}

          <Text className="h2 mt-2" tag="h1" field={article.articleTitle} />
          <Text
            className="body-large text-grey mt-2 mt-md-3 mt-lg-2"
            tag="p"
            field={article.articleStrapline}
          />

          {(authorsLength || article.articleContributor) && (
            <div className="row">
              <div className="col-12 col-md-9 col-lg-12">
                {authorsLength > 0 && (
                  <ArticleAuthors authors={article.articleAuthor.targetItems} className="mt-3" />
                )}
                {article.articleContributor.targetItems.length > 0 && (
                  <ArticleContributors
                    contributors={article.articleContributor.targetItems}
                    className="mt-3"
                  />
                )}
              </div>
            </div>
          )}
        </div>

        <div
          className={`col-12 col-lg-6 mb-2 mb-lg-0 position-relative ${styles.articleHeroImage}`}
        >
          {article.articleImage?.src && (
            <NextImage
              field={article.articleImage as ImageField}
              lazy={false}
              fill
              style={{ objectFit: 'cover' }}
              sizes="(max-width: 992px) 100vw, 33vw"
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default ArticleHeroImageRight;
